<template>
  <div>
    <v-data-table
      select-strategy="all"
      fixed-header
      :headers="headers"
      :items="consumers"
      class="max-h-[60dvh]"
      item-value="id"
      @click:row="handleClickRow"
    />
  </div>
</template>

<script setup lang="ts">
defineProps<{ consumers: any[] }>();
const emits = defineEmits(['consumerClick']);

const headers = [
    {
        title: 'Patient',
        key: 'name',
        value: (item) => item.information.name
    },
    {
        title: 'Produits dans l\'armoire',
        key: 'item_count',
        value: (item) => item?.medicine_cabinet?.item_count
    },
    {
        title: 'Produits périmés',
        key: 'expired_count',
        value: (item) => item?.medicine_cabinet?.item_count
    }
];

/**
 * Handle consumer click row.
 */
const handleClickRow = (event: PointerEvent, row) => {
    emits('consumerClick', row.item);
};
</script>
